import { useEffect } from "react";
import { saveRequested } from "@/features/shell/slice";
import { appEvents } from "@/legacy/react/events";
import { useAppDispatch } from "./hooks";

/**
 * Eventi del bus legacy che diventano comandi dello shell. Verso opposto del listener middleware in
 * legacyBridge.ts. Oggi un solo evento: `save-changes` (ConfigItem, LayoutDesignGeneral). Sparisce in fase 8.
 */
export function LegacyEventsBridge() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const onSave = () => dispatch(saveRequested());
    appEvents.$on("save-changes", onSave);
    return () => appEvents.$off("save-changes", onSave);
  }, [dispatch]);
  return null;
}
